import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'DELETE_CONTRACTOR_INVOICES';

export async function deleteContractorInvoice(
    userToken: string,
    id: number
) {
    try {
         

        const response = await axios.delete(
             
            `${URL}/contractor-invoices/${id}/`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de suppression d\' factures fournisseurs',
            error: error
        });
    }
}
